module.exports = __webpack_public_path__ + "static/media/logo-foreign-bsc.6e0d03dd.svg";